import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { useUpdateSiteControllerSettingNotUsing } from "../../../../model/not-using/use-case";

type Props = {
	hotelID: string;
	onResetViewModel: () => void;
};

export const useSettingsSiteControllerNotUsing = ({ hotelID, onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdate: _onUpdate } = useUpdateSiteControllerSettingNotUsing();
	const onUpdate = useCallback(async () => {
		showLoadingScreenCallback();

		const { errors } = await _onUpdate({ hotelID }).finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "サイコン設定（CHILLNNで管理する）を更新しました",
			});
			onResetViewModel();
		}
	}, [_onUpdate, hideLoadingScreenCallback, hotelID, onResetViewModel, showLoadingScreenCallback]);

	return {
		onUpdate,
	};
};
